import { Paperclip, X } from 'lucide-react'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Hidden multi-file input with removable chips — the chat composer pattern,
 * reused by the ticket create dialog and the comment composer.
 */
export function AttachmentPicker({
  files,
  onChange
}: {
  files: File[]
  onChange: (files: File[]) => void
}) {
  const { t } = useTranslation('tickets')
  const fileInput = useRef<HTMLInputElement>(null)

  return (
    <div>
      {files.length > 0 && (
        <div className="mb-2 flex flex-wrap gap-2">
          {files.map((file, i) => (
            <span
              key={`${file.name}-${i}`}
              className="flex items-center gap-1 rounded-full bg-muted px-2.5 py-1 text-xs text-ink/70"
            >
              <Paperclip className="h-3 w-3" />
              <span className="max-w-[140px] truncate">{file.name}</span>
              <button
                type="button"
                onClick={() => onChange(files.filter((_, idx) => idx !== i))}
                aria-label="Remove file"
                className="border-0 bg-transparent p-0"
              >
                <X className="h-3 w-3" />
              </button>
            </span>
          ))}
        </div>
      )}
      <button
        type="button"
        onClick={() => fileInput.current?.click()}
        className="inline-flex items-center gap-1.5 rounded-full border border-ink/15 bg-transparent px-3 py-1.5 text-xs font-medium text-ink/70 transition-colors hover:border-ink/30 hover:text-ink"
      >
        <Paperclip className="h-3.5 w-3.5" />
        {t('form.add_photos')}
      </button>
      <input
        ref={fileInput}
        type="file"
        multiple
        hidden
        accept="image/jpeg,image/png,application/pdf"
        onChange={(e) => {
          const picked = e.target.files ? Array.from(e.target.files) : []
          if (picked.length) onChange([...files, ...picked])
          e.target.value = ''
        }}
      />
    </div>
  )
}
